import React, { useState, useEffect } from 'react';

const slides = [
  'https://bz-assets.s3.us-west-2.amazonaws.com/sephora/processed_pngs/frames/2.png',
  'https://bz-assets.s3.us-west-2.amazonaws.com/sephora/processed_pngs/frames/3.png',
  'https://bz-assets.s3.us-west-2.amazonaws.com/sephora/processed_pngs/frames/4.png',
  'https://bz-assets.s3.us-west-2.amazonaws.com/sephora/processed_pngs/frames/5.png',
  'https://bz-assets.s3.us-west-2.amazonaws.com/sephora/processed_pngs/frames/6.png',
  'https://bz-assets.s3.us-west-2.amazonaws.com/sephora/processed_pngs/frames/7.png',
  'https://bz-assets.s3.us-west-2.amazonaws.com/sephora/processed_pngs/frames/8.png',
  'https://bz-assets.s3.us-west-2.amazonaws.com/sephora/processed_pngs/frames/9.png',
  'https://bz-assets.s3.us-west-2.amazonaws.com/sephora/processed_pngs/frames/10.png',
  'https://bz-assets.s3.us-west-2.amazonaws.com/sephora/processed_pngs/frames/21.png',
];

const Slideshow = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
    }, 3000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="slideshow">
      <div className="background-image">
        <img src="https://bz-assets.s3.us-west-2.amazonaws.com/sephora/processed_pngs/macbook.png" alt="Laptop" />
      </div>
      <div className="slides">
        {slides.map((slide, index) => (
          <img
            key={index}
            src={slide}
            alt={`Slide ${index + 1}`}
            className={index === currentSlide ? 'active' : ''}
          />
        ))}
      </div>
    </div>
  );
};

export default Slideshow;
